function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 4,
  fill: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 17.74l950.68-.94L976 683.2l-477.16-1.23L24 17.74zM499.85 17.74l235.9 664.23M183.29 239.78l791.4-.94"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.58 461.81l629.09-1.88h1V459"
}));

function SvgTrapezium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 700",
    preserveAspectRatio: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrapezium);
export default __webpack_public_path__ + "static/media/trapezium.dacff88a.svg";
export { ForwardRef as ReactComponent };